import {
  InputGroup,
  InputRow,
  EmptyInput,
  RadioYesNoInput,
  ModelDateDMY,
} from '@equifinance/shared';
import { PaddedSection } from '../../components/Section';
import { useAccountContext } from '../../../../contexts';

export const DebtManagementPlanRefName = 'debt-management-plan';

export default function DebtManagementPlan() {
  const { account } = useAccountContext();

  const {
    dmpDetails,
    errors,
    warnings,
  } = account ?? {};

  return (
    <PaddedSection
      id={dmpDetails?.id}
      refName={DebtManagementPlanRefName}
      title="Debt Management Plan"
      errors={errors}
      warnings={warnings}
    >

      <InputGroup>
        <InputRow>
          <RadioYesNoInput
            label="Have any of the Applicants ever been in a DMP?"
            field="dmpDetails.everBeenInDMP"
            required
          />

          {dmpDetails?.everBeenInDMP ? (
            <ModelDateDMY
              label="When did the Applicants last enter a DMP?"
              field="dmpDetails.dateLastEnterDMP"
              required
            />
          ) : (
            <EmptyInput />
          )}

        </InputRow>
        {
          dmpDetails?.everBeenInDMP && (
            <InputRow>
              <RadioYesNoInput
                label="Are any of the Applicants currently in a DMP?"
                field="dmpDetails.currentlyInDMP"
                required
              />

              {dmpDetails?.currentlyInDMP === false ? (
                <ModelDateDMY
                  label="When did the Applicants last exit a DMP?"
                  field="dmpDetails.dateLastExitDMP"
                  required
                />
              ) : (
                <EmptyInput />
              )}

            </InputRow>
          )
        }
      </InputGroup>
    </PaddedSection>
  );
}
